import { Routes } from '@angular/router';

import { AuthGuard } from '@lib/auth';
import { provideNewTasksCountPolling } from '@lib/tasks';

import { clearMemberProfileGuard } from '@hm/core/guards/clear-member-profile.guard';
import { clientProfileResolver } from '@hm/core/resolvers/client-profile.resolver';

import { chatRoutes } from '@lib/chat/chat.routes';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/access/access-guest/access-guest.component').then(c => c.AccessGuestComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/login/login.component').then(c => c.LoginComponent),
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./pages/access/access-authorized/access-authorized.component').then(c => c.AccessAuthorizedComponent),
    canActivate: [AuthGuard],
    providers: [provideNewTasksCountPolling()],
    children: [
      {
        path: '',
        // Component was hidden in cause of unusability by users till new HomePage with HM Actions will be implemented
        //   loadComponent: () => import('./pages/home/home.component').then(c => c.HomeComponent),
        pathMatch: 'full',
        redirectTo: 'members',
      },
      {
        path: 'members',
        loadComponent: () => import('./pages/members/members-list/members-list.component').then(c => c.MembersListComponent),
      },
      {
        path: 'members/:id',
        loadComponent: () => import('./pages/members/member-hub/member-hub.component').then(c => c.MemberHubComponent),
        resolve: { clientData: clientProfileResolver },
        canDeactivate: [clearMemberProfileGuard],
        children: [
          {
            path: 'profile',
            loadComponent: () => import('./pages/members/member-profile/member-profile.component').then(c => c.MemberProfileComponent),
          },
          {
            path: 'guarantees',
            loadComponent: () => import('./pages/members/member-guarantees/member-guarantees.component').then(c => c.MemberGuaranteesComponent),
          },
          {
            path: 'prescriptions',
            loadComponent: () => import('./pages/members/member-prescriptions/member-prescriptions.component').then(c => c.MemberPrescriptionsComponent),
          },
          {
            path: 'appointments',
            loadComponent: () => import('./pages/members/member-appointments/member-appointments.component').then(c => c.MemberAppointmentsComponent),
          },
          {
            path: 'documents',
            loadComponent: () => import('./pages/members/member-documents/member-documents.component').then(c => c.MemberDocumentsComponent),
          },
          // {
          //   path: 'communications',
          //   loadComponent: () => import('./pages/members/member-communications/member-communications.component').then(c => c.MemberCommunicationsComponent),
          // },
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'profile',
          },
        ],
      },
      {
        path: 'members/:id/guarantees/create',
        loadComponent: () => import('./pages/create-medical-service/create-medical-service.component').then(c => c.CreateMedicalServiceComponent),
        resolve: { clientData: clientProfileResolver },
        canDeactivate: [clearMemberProfileGuard],
      },
      {
        path: 'members/:id/prescriptions/:prescriptionId/plannings/:planningId',
        loadComponent: () => import('./pages/members/member-appointment/member-appointment.component').then(c => c.MemberAppointmentComponent),
        canDeactivate: [clearMemberProfileGuard],
      },
      {
        path: 'medical-services',
        loadComponent: () => import('./pages/medical-services/medical-services').then(c => c.MedicalServicesComponent),
      },
      {
        path: 'visits',
        loadComponent: () => import('./pages/visits/visits-list.component').then(c => c.VisitsListComponent),
      },
      {
        path: 'chat/threads',
        loadComponent: () => import('../../../../packages/chat/src/chat.component').then(c => c.ChatComponent),
        children: chatRoutes,
      },
      {
        path: 'recommendations',
        loadComponent: () => import('@lib/shared-ui/modules/recommendations/recommendations.component').then(c => c.RecommendationsComponent),
      },
      {
        path: 'tasks',
        loadChildren: () => import('@lib/tasks').then(m => m.TASKS_ROUTES),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
